<div [ngClass]="checkValidated(service.validated)" *ngIf="user">
  <mat-grid-list class="quot-service-grid" cols="15" rowHeight="100" [ngClass]="{'option': isOption()}">
    <mat-grid-tile [colspan]="isDesktop ? 11 : 15" class="quot-service-element">
      <div class="quot-service-inf">
        <h2 class="quot-service-name lw-grey">{{ service.name }}</h2>
        <p class="lw-grey">{{ service.description }}</p>
      </div>
    </mat-grid-tile>

    <mat-grid-tile class="right quot-service-price" [colspan]="isDesktop ? 3 : 14">
      <ng-container *ngIf="!isDesktop">
        <div class="information-title">
          <p>Détails</p>
          <p>du prix</p>
        </div>
        <div class="separator"></div>
      </ng-container>
      <div class="amount">
        <div class="header" [ngClass]="{'mobile' : !isDesktop, 'not-mobile' : isDesktop}">Quantité</div>
        <div class="content" [ngClass]="{'mobile' : !isDesktop, 'not-mobile' : isDesktop}">{{ service.unit_amount }} {{ globalDataService.getUnitLabel(service.id_unit_type) }}</div>
      </div>
      <div class="separator">
      </div>
      <div class="price-popup-uprice">
        <div class="header" [ngClass]="{'mobile' : !isDesktop, 'not-mobile' : isDesktop}" >Prix total</div>
        <div class="content" [ngClass]="{'mobile' : !isDesktop, 'not-mobile' : isDesktop}">{{ calculateUnitServicePrice() | currency: 'EUR':'symbol' }}</div>
      </div>
    </mat-grid-tile>
  </mat-grid-list>

  <div class="materials-container">
    <ng-container *ngIf="materials && materials.length > 0">
      <mat-grid-list cols="6" rowHeight="100">
        <ng-container *ngFor="let material of materials">
          <mat-grid-tile [colspan]="getColSpan()">
            <div class="material-container">
              <div class="photo-container">
                <ng-container *ngIf="material
                 && material._related
                 && material._related.material_version_images
                 && material._related.material_version_images[0]">
                  <img [src]="getPhoto(material._related.material_version_images[0].id_image)"  (click)="openPhoto(material)">
                </ng-container>
              </div>
              <div class="info-container">
                <ng-container *ngIf="material._related.material_versions && material._related.material_versions[0].name; else noName">
                  <div class="info">{{material._related.material_versions[0].name}}</div>
                </ng-container>
                <ng-template #noName>
                  <div class="info">Titre non renseigné</div>
                </ng-template>
                <span class="price">Prix unitaire :
                <ng-container *ngIf="material._related.material_versions
                  && material._related.material_versions[0]
                  && material._related.material_versions[0].unit_quantity
                  && material._related.material_versions[0].unit_price; else noPrice">
                  {{ material._related.material_versions[0].unit_price | currency: 'EUR' }}
                </ng-container>
                <ng-template #noPrice>
                  non renseigné
                </ng-template>
              </span>
              </div>
            </div>
          </mat-grid-tile>
        </ng-container>
      </mat-grid-list>
    </ng-container>
  </div>
</div>
